import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.accounting.closing');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-accounting-closing',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.accounting.closing/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccountingClosingComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public selectedMonth: string = '';
    public summary: any = {};
    public feeStatus: any[] = [];
    public settlement: any[] = [];
    public categories: any = {};
    public reportText: string = '';
    public isGenerating: boolean = false;
    public months: string[] = [];

    public async ngOnInit() {
        await this.service.init();
        this.selectedMonth = WizRoute.segment?.month || this.getCurrentMonth();
        this.generateMonthOptions();
        await this.load();
        await this.service.render();
    }

    public getCurrentMonth() {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    }

    public generateMonthOptions() {
        const now = new Date();
        this.months = [];
        for (let i = 0; i < 12; i++) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            this.months.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
        }
    }

    public async changeMonth() {
        await this.load();
    }

    public async load() {
        let res = await wiz.call("closing_data", { month: this.selectedMonth });
        if (res.code === 200) {
            this.summary = res.data?.summary || {};
            this.feeStatus = res.data?.fee_status || [];
            this.settlement = res.data?.settlement || [];
            this.categories = res.data?.categories || {};
        }
        await this.service.render();
    }

    public async generateReport() {
        this.isGenerating = true;
        this.reportText = 'AI 리포트 생성 중...';
        await this.service.render();

        let res = await wiz.call("generate_report", { month: this.selectedMonth });
        if (res.code === 200) {
            this.reportText = res.data?.report_text || '';
        } else {
            this.reportText = '리포트 생성 실패: ' + (res.data?.message || '');
        }
        this.isGenerating = false;
        await this.service.render();
    }

    public getCategoryKeys() {
        return Object.keys(this.categories);
    }
}

export default PageAccountingClosingComponent;